import React, {Component} from 'react';
import {Divider, Row, Button, message} from 'antd';
import Title from 'antd/lib/typography/Title';
import Form from '../../lib/ui/form';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { BasicHeader } from '../../components/basic_header'
import { showErrorInNotification } from '../../lib/util';
import { setting_quick_menu } from '../../util/ui_util';

const export_setting_field=[
    {
        index: 'groups',
        name: "Groups",
        type: 'bool'
    },
    {
        index: 'repositories',
        name: "Repositories",
        type: 'bool'
    },
    {
        index: 'tabels',
        name: "Tables",
        type: 'bool'
    }
]
class ImportExportSetting extends Component {
    constructor(props) {
        super(props)

        this.state = {
            export_data: {},
            import_data:{}
        }

        this.import_data=RESTExecutor.post().config({
            label:'import',
            headers:{Accepts: 'multipart/form-data'}    
        }).callbacks((success)=>{
            console.log("success",success)
        },(error)=>{
            showErrorInNotification(error)
        }).connect(props.domains.settings);

        this.export_data=RESTExecutor.post().config({
            label:'export'
        }).callbacks((success)=>{
            console.log("download url",success)
            window.open(success.result.url, '_blank');

        },(error)=>{
            showErrorInNotification(error)
        }).connect(props.domains.settings);


    }

    uploadFile=()=>{
        this.setState({
            form_submitted:true
        })
        let data=this.state.import_data.file;
        if(!data){
            message.warn("Cannot upload empty data...");
            return;
        }
        let formdata=new FormData();
        formdata.append('file',data);
        // formdata.append('source_id',this.source_id);

        this.import_data.forId(this.source_id)
        .execute(formdata);

    }

   

    render() {

        let import_data_resp=this.import_data.response();
        let export_data_resp=this.export_data.response();

        return (
            <div>
                <BasicHeader no_back title="Import/Export"
                    menu_items={setting_quick_menu}
                    />
                <div
                    className='default-card'
                    style={{
                    padding: 8
                }}>
                    <Title className='card-title'>Import Setting</Title>

                    <Form
                    hideTitle
                    forCreate={true}
                    initialData={this.state.import_data || {}}
                    submitted={this.state.submitted}
                    onChange={(data) => {
                        this.setState({ import_data: data })
                    }}
                    fields={[
                        { name: "Upload File",
                        index: 'file',
                        type: 'file',
                        compress: true
                        }
                    ]}
                    submitting={{}}
                    errorMessage={import_data_resp.error_message||{}}
                    validationErrors={import_data_resp.validation_errors||{}}
                />
                 <br></br>
                <Row type='flex'>
                        <Button type='primary'
                        onClick={()=>{
                            this.uploadFile()
                        }}
                        loading={import_data_resp.fetching}
                        disabled={import_data_resp.fetching}
                        >Upload</Button>
                </Row>
                    
                </div>
                <Divider/>
                <div
                    className='default-card'
                    style={{
                    padding: 8
                }}>
                    <Title className='card-title'>Export Setting</Title>
                    <Form
                    hideTitle
                    forCreate={true}
                    initialData={this.state.export_data || {}}
                    submitted={this.state.submitted}
                    onChange={(data) => {
                        this.setState({ export_data: data })
                    }}
                    fields={export_setting_field}
                    submitting={{}}
                    errorMessage={{}}
                    validationErrors={{}}
                />
                    <br></br>
                    <Row type='flex'>
                        <Button type='primary'
                        loading={export_data_resp.fetching}
                        disabled={export_data_resp.fetching}
                        onClick={()=>{
                            this.export_data.execute(this.state.export_data);
                        }}
                        >Download</Button>
                    </Row>
                </div>

            </div>
        );
    }

    componentDidMount(){
        try{
            window.header_assigner.assignTitle("Import/Export Setting");
      
        }catch(e){}
    }
}

export default withDomains(ImportExportSetting,"settings");
